import type { RouteRecordRaw } from 'vue-router'

export const NotFondRoute: RouteRecordRaw = {
  path: '/404',
  name: 'NotFoundView',
  component: () => import('../ui/NotFoundView.vue'),
  meta: {
    layout: 'emptyLayout'
  }
}

export const NotFoundRedirectRoutes: RouteRecordRaw = {
  path: '/:catchAll(.*)',
  redirect: NotFondRoute,
  meta: {
    disableOnThemeConstructor: true
  }
}
